import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext, useMatchRoute } from "@tanstack/react-router";

import { BackgroundParticles } from "@/components/layout/BackgroundParticles";
import { Header } from "@/components/layout/Header";
import { Sidebar } from "@/components/layout/Sidebar";

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  const matchRoute = useMatchRoute();
  const isLogin = matchRoute({ to: "/login" });

  if (isLogin) {
    return <Outlet />;
  }

  return (
    <>
      <BackgroundParticles />
      <div className="relative z-10 min-h-screen flex bg-transparent text-text grid-lines">
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <Header />
          <main className="flex-1 overflow-auto p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
}
